export default "__VITE_ASSET__8ZdnT3uV__"